import { createClient } from '@supabase/supabase-js';

// ── Database environment switch ───────────────────────────────────────────────
// Change REACT_APP_ENV in client/.env to 'dev' or 'prod', then restart npm start
const isDev = (process.env.REACT_APP_ENV || 'prod').trim() === 'dev';

const supabaseUrl = isDev
  ? process.env.REACT_APP_DEV_SUPABASE_URL
  : (process.env.REACT_APP_SUPABASE_URL || 'https://xvhellooihpelwifxuik.supabase.co');

const supabaseAnonKey = isDev
  ? process.env.REACT_APP_DEV_SUPABASE_ANON_KEY
  : (process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh2aGVsbG9vaWhwZWx3aWZ4dWlrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjM5ODI4OTMsImV4cCI6MjAzOTU1ODg5M30.o-2LcQcZSnHWy-O_sKRxMhiW1gzAEa5HJkKIvA3ujI0');

console.log(`🗄️ [Supabase] Environment → ${isDev ? 'DEV' : 'PROD'} (${supabaseUrl})`);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false, // Web app doesn't need persistent sessions for image uploads
  }
});

// S3 Configuration for Supabase Storage
export const S3_CONFIG = {
  region: 'us-east-2',
  endpoint: 'https://xvhellooihpelwifxuik.storage.supabase.co/storage/v1/s3',
  credentials: {
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY || '2ac94ab542ddcbd5ee4ee0935713063e',
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY || '009141c716b9e62ca42c429c996622fb02f1468fda8185ae83931b77f7f1b9f5',
  },
  forcePathStyle: true,
};
